// Per-tick quantization. Reduces float drift across runs and produces stable hashes.
// Position step = 1/4096 world units. Velocity step = 1/2048 units/sec.

import type { Vec2 } from "./Vec2.js";

const POSITION_QUANTUM = 4096;
const VELOCITY_QUANTUM = 2048;

export function q(x: number): number {
  return Math.round(x * POSITION_QUANTUM) / POSITION_QUANTUM;
}

export function qVel(x: number): number {
  return Math.round(x * VELOCITY_QUANTUM) / VELOCITY_QUANTUM;
}

export function qVec(v: Vec2): Vec2 {
  return { x: q(v.x), y: q(v.y) };
}

export function qVelVec(v: Vec2): Vec2 {
  return { x: qVel(v.x), y: qVel(v.y) };
}

// Hot-path variants — mutate the vector in place to avoid per-tick allocation.
// Use these inside tickMatch; the pure variants stay available for tests and
// non-hot-path callers.
export function qVecInPlace(v: Vec2): void {
  v.x = q(v.x);
  v.y = q(v.y);
}

export function qVelVecInPlace(v: Vec2): void {
  v.x = qVel(v.x);
  v.y = qVel(v.y);
}
